module.exports = __webpack_public_path__ + "img/premium_bg.159f768b.webp";